import { render } from "./CloseButton.vue?vue&type=template&id=2cdd3b4c"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"
script.render = render

export default script